<template>
  <div class="article-title-bar" :style="articleTitleBarStyl" ref="articleTitleBarRefs">
    <div class="title-bar">
      <div class="main-title" :style="titleBarMainTitleStyl" v-if="specialDataObj.mainTitleStatus">{{specialDataObj.mainTitleName}}</div>
      <div class="desc-title" :style="descTitleStyl" v-if="specialDataObj.subtitleStatus">{{specialDataObj.subtitleName}}</div>
      <div class="link-btn" @click="checkMore" v-if="buttonContent.isShowButton">{{buttonContent.buttonName}}</div>
    </div>
  </div>
</template>

<script>
import { checkMoreClickFn, getDataLrFn } from './commonModuleFn'
export default {
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data(){
      return {
          specialDataObj: this.receiveProps.tempData.specialData,
          specialStyleObj: this.receiveProps.tempData.specialStyle,
          buttonContent: this.receiveProps.tempData.buttonData,
          isBanner: true, // true为通栏   false为二分栏或1-2分栏
      }
  },
  mounted(){
      
        let classArr = this.$refs.articleTitleBarRefs.parentNode.parentNode.classList
        for(var i=0;i<classArr.length;i++){ //获取父节点  el-col-24  el-col-12
        if(classArr[i]=='el-col-12' || classArr[i]=='el-col-16'){
          this.isBanner = false
        } 
      }
      getDataLrFn(this)
    //   el-col-16
  },
  methods:{
      checkMore() {
          checkMoreClickFn(this.buttonContent, this.specialDataObj, this)
      }
  },
  computed: {
    articleTitleBarStyl(){
      return {
        minHeight: this.buttonContent.isShowButton&&this.buttonContent.buttonName? '25px': '',
        marginBottom: !this.specialDataObj.mainTitleStatus&&!this.specialDataObj.subtitleStatus&&!this.buttonContent.isShowButton?'': '16px',
        marginLeft: this.isBanner? '': '24px'
      }
    },
    titleBarMainTitleStyl() {
      let {titlePosition, mainTitleNameSize, mainTitleBold, mainTitleColor} = this.specialStyleObj
      return {
          textAlign: titlePosition,
          fontSize: `${mainTitleNameSize}px`,
          fontWeight: mainTitleBold? '700': '',
          color: mainTitleColor,
      };
    },
    descTitleStyl(){
        let {titlePosition, subtitleSize, subtitleBold, subtitleColor} = this.specialStyleObj
        return {
            fontSize: `${subtitleSize}px`,
            fontWeight: subtitleBold? '700': '',
            color: subtitleColor,
            textAlign: titlePosition
        }
    },
  },
};
</script>

<style lang="less" scoped>
.article-title-bar{
    position: relative;
    // min-height: 25px;
    // margin-bottom: 16px;
    .desc-title{
      margin: 8px auto 0;
    }
    .link-btn{
        position: absolute;
        top: 0;
        right: 0;
        font: 400 14px PingFangSC-Regular, PingFang SC;
        color: #333333;
        &:hover{
            cursor: pointer;
        }
    }
}
</style>